import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { bookings } from "../../../../../redux/bookings/action";
import { selectBookingsListItems } from "../../../../../redux/bookings/selector";
import Table from "../../../../../common/components/table";
import { selectListItems } from "../../../../../redux/library/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";

const ManagementBookings = () => {
	const dispatch = useAppDispatch()
    const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
    const itemsData = useSelector(selectBookingsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'OwnerType', headerName: 'OwnerType', sortable: true },
    { field: 'IsActive', headerName: 'Active',  cellRenderer: 'yesNoRenderer' },
    { field: 'InvoiceNumber', headerName: 'InvoiceNumber', sortable: true, filter: true },
    { field: 'ShippingStatusId',headerName: 'Shipment Status',
    cellRenderer: 'libraryRendererComponent',
    cellRendererParams: { library: libraryData?.result?.ShippingStatus },
    sortable: true,
    filter: false, },
    { field: 'Description', headerName: 'Description', sortable: true, filter: true },
    { field: 'CreatedOnUtc', headerName: 'CreatedOn',isDateValueFormat:true },
    { field: 'ModifiedOnUtc', headerName: 'ModifiedOn',isDateValueFormat:true },
        ]);
      }
      const fetchBookings=()=>{
        dispatch(bookings.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/smart-booking/bookings/list`,entity:'bookings',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
      const handleDelete=(data: any)=>{
        dispatch(bookings.delete({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/smart-booking/bookings/delete`,
          entity: 'bookings',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(bookings.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/smart-booking/bookings/list`,entity:'bookings',jsonData:{
             "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }

      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
	useEffect(() => {
        createColumnDefs()
        fetchBookings()
	}, [pageData,pageSize])
  
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      name: 'Add OrderBooking',
      callback: () => handleAdd(),
    }
  ];
	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
:
		<Table columnData={columnDefs} rowData={itemsData?.result?.items}  paginationData={itemsData?.result?.pagination} setPageData={setPageData}
    setPageSize={setPageSize} additionButtons={additionButtons} onEdit={handleEdit} onDelete={handleDelete} headingName="Bookings"/>
  }
    </>      
     
	);
};

export default ManagementBookings;


